"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = exports.keyframes = exports.createMakeStyles = void 0;
const createMakeStyles_1 = require("./createMakeStyles");
const createUseCssAndCx_1 = require("./createUseCssAndCx");
const serialize_1 = require("@emotion/serialize");
const utils_1 = require("@emotion/utils");
const react_1 = require("./@emotion/react");
const cache_1 = require("./cache");
/** https://github.com/garronej/tss-react */
function createMakeStyles(params) {
    const { useTheme, cache } = params;
    const { useCssAndCx } = createUseCssAndCx_1.createUseCssAndCx({
        getRegisteredStyles: utils_1.getRegisteredStyles,
        insertStyles: utils_1.insertStyles,
        serializeStyles: serialize_1.serializeStyles,
        "useEmotionCache": cache !== undefined
            ? () => cache
            : () => { var _a; return (_a = react_1.useEmotionCache()) !== null && _a !== void 0 ? _a : cache_1.getCache(); },
    });
    const { makeStyles } = createMakeStyles_1.createMakeStyles({
        useTheme,
        useCssAndCx,
    });
    function useStyles() {
        const theme = useTheme();
        const { css, cx } = useCssAndCx();
        return { theme, css, cx };
    }
    return { makeStyles, useStyles };
}
exports.createMakeStyles = createMakeStyles;
/** Reexport from @emotion/react */
var react_2 = require("@emotion/react");
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return react_2.keyframes; } });
var GlobalStyles_1 = require("./GlobalStyles");
Object.defineProperty(exports, "GlobalStyles", { enumerable: true, get: function () { return GlobalStyles_1.GlobalStyles; } });
//# sourceMappingURL=index.js.map